import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://insight.wfp.org/tea-with-fatou-2c67295d78a0"
      }}>{`Fatou`}</a>{` lives in Smara, one of five Sahrawi refugee camps in South Western Algeria. Thousands of refugee families arrived here in 1975 from Western Sahara and have been defying the extreme weather and isolation of the Sahara Desert ever since.`}</p>
    <p>{`“Life is difficult here, not only because of the weather,” Fatou says. “For us youth there is not much to do. There are some small projects in the camps, but I want to go study. I want to discover what is beyond the camps, meet other cultures, talk to people from other countries. This is why I want to become a Spanish teacher — I want to be able to talk to foreigners and help other Sahrawi refugees learn.”`}</p>
    <p>{`For Fatou, the meals she has with her family are her favourite part of the day. Every month, WFP distributes food rations consisting of wheat flour, barley, vegetable oil, pulses, rice and sugar, which cover the refugees’ basic food and nutrition needs.`}</p>
    <p>{`Generous contributions from the EU enabled WFP to support Fatou and more than `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=DZ02&year=2019#/15300"
      }}>{`130,000`}</a>{` vulnerable Sahrawi refugees living in camps in the desert of Algeria. In 2019, the European Commission was the largest donor to WFP’s work in support of Sahrawi refugees in the country.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      